/**
 * @generated SignedSource<<98ef83a92176ee3eee0203814def17fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteTempoIntegrationInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteTempoIntegrationMutation$variables = {
  input: DeleteTempoIntegrationInput;
};
export type DeleteTempoIntegrationMutation$data = {
  readonly deleteTempoIntegration: {
    readonly company: {
      readonly id: string;
      readonly tempoOauthTokenApplied: boolean | null;
      readonly tempoOauthClientId: string | null;
      readonly tempoOauthClientSecret: string | null;
    } | null;
  } | null;
};
export type DeleteTempoIntegrationMutation = {
  variables: DeleteTempoIntegrationMutation$variables;
  response: DeleteTempoIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteTempoIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteTempoIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthTokenApplied",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthClientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tempoOauthClientSecret",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteTempoIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteTempoIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "761fe1eb9d9c71e1915f4be6bae75e8b",
    "id": null,
    "metadata": {},
    "name": "DeleteTempoIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteTempoIntegrationMutation(\n  $input: DeleteTempoIntegrationInput!\n) {\n  deleteTempoIntegration(input: $input) {\n    company {\n      id\n      tempoOauthTokenApplied\n      tempoOauthClientId\n      tempoOauthClientSecret\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d1971c189ad87af163cacf503b31ffe7";

export default node;
